import React from "react";

import {
  IFluid,
  ILocalFile
} from "src/types/local-files";

import { IProfileData } from "../../pages/about-us";
import getProfile from "../../templates/utils/getProfile";
import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper,
  fontSpaceHelper,
  fontWeightHelper
} from "../../theme/theme-helper";
import ArticleTeaser from "../article-teaser";
import { FullWidthColumnWrapper } from "../confines-wrappers";
import { ISimpleTag } from "../full-width-teaser/full-width-teaser";
import Icon from "../icon";
// import InsightsTeaserMinimal from '../insights-teaser-minimal';
import Link from "../link";

interface IProps {
  invertContrast?: boolean;
  articles: IRelatedInsightsArticle[];
  authorName?: string;
}

interface IRelatedInsightsContainer {
  invertContrast: boolean;
}

export interface IRelatedInsightsArticle {
  node: {
    title: string;
    created: string;
    path: {
      alias: string;
    };
    relationships: {
      field_labs_tags?: ISimpleTag[];
      author: IProfileData;
      field_cover_image: ILocalFile<IFluid>;
    };
  };
}

const RelatedInsightsContainer = styled<IRelatedInsightsContainer, "div">(
  "div"
)`
  background-color: ${props =>
    props.invertContrast ?
      ({ theme }) => colourHelper({
        theme,
        variant: "altLightGrey"
      }) :
      ({ theme }) => colourHelper({
        theme,
        variant: "white"
      })};

  h2 {
    margin: 0;
    color: ${({ theme }) => colourHelper({
    theme,
    variant: "black"
  })};
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "title"
  })};
    font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "heavy"
    })};
    line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "small"
    })};
    text-align: center;

    .hr {
      display: block;
      padding-top: 2.4rem;

      span {
        display: block;
        margin: 0 auto;
        width: 5rem;
        height: 0.5rem;
        background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "brandColor"
    })};
      }
    }
  }

  .articles-container {
    transition: 0.2s ease-in-out;
    padding-top: 6.8rem;

    .articles-wrapper {
      transition: 0.2s ease-in-out;
      padding-top: 3.8em;

      &:first-child {
        padding-top: 0;
      }

      .more-link-container {
        position: relative;
        padding-top: 66.66666667%;

        .more-link-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "white"
    })};

          .more-link {
            margin: 0;
            color: ${({ theme }) => colourHelper({
    theme,
    variant: "black"
  })};
            font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_2"
    })};
            font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "heavy"
    })};
            line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "small"
    })};
            text-align: center;

            a {
              display: block;
              position: relative;
              padding-top: 3.2rem;
              color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "black"
    })};

              &:hover {
                color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "brandColor"
    })};

                .icon-wrapper {
                  .icon {
                    fill: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "brandColor"
    })};
                  }
                }
              }

              .keyword {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "small_3"
    })};
                font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "light"
    })};
                line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "normalized"
    })};
                letter-spacing: ${({ theme }) =>
    fontSpaceHelper({
      theme,
      variant: "medium"
    })};
                text-transform: uppercase;
              }

              .icon-wrapper {
                display: block;
                padding-top: 3.2rem;
              }
            }
          }
        }
      }
    }
  }

  @media (min-width: 600px) {
    h2 {
      font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "display_1"
    })};
    }

    .articles-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      .articles-wrapper {
        padding-top: 6.8rem;
        width: 50%;

        &:nth-child(-n + 2) {
          padding-top: 0;
        }

        &:nth-child(odd) {
          padding-right: 2%;

          &:last-child {
            padding-left: 1%;
            padding-right: 1%;
          }
        }

        &:nth-child(even) {
          padding-left: 2%;
        }
      }
    }
  }

  @media (min-width: 960px) {
    h2 {
      font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "display_2"
    })};
    }

    .articles-container {
      .articles-wrapper {
        padding-top: 8.2rem;
        width: 33.33%;

        &:nth-child(-n + 3) {
          padding-top: 0;
        }

        &:nth-child(3n + 1) {
          padding-left: 0;
          padding-right: 2%;

          &:last-child {
            padding-left: 1%;
            padding-right: 1%;
          }
        }

        &:nth-child(3n + 2) {
          padding-left: 1%;
          padding-right: 1%;

          &:last-child {
            padding-left: 2%;
            padding-right: 0;
          }
        }

        &:nth-child(3n + 3) {
          padding-left: 2%;
          padding-right: 0;

          &:last-child {
            padding-left: 2%;
            padding-right: 0;
          }
        }
      }
    }
  }

  @media (min-width: 1280px) {
    h2 {
      font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "display_3"
    })};
    }
  }

  @media (min-width: 1440px) {
    .articles-container {
      .articles-wrapper {
        .more-link-container {
          .more-link-wrapper {
            .more-link {
              font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "title"
    })};

              .keyword {
                font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "small_3"
    })};
              }
            }
          }
        }
      }
    }
  }
`;

const RelatedInsights = ({
  invertContrast, authorName, articles
}: IProps) => {
  const invert = invertContrast ? invertContrast : false;
  const authorFirstName = authorName ? authorName.split(" ")[ 0 ] : "";
  const nameSlugRegex = /[\s'-]/i;
  let nameSlug = "";

  if (authorName) {
    nameSlug = authorName.replace(nameSlugRegex, "-").toLowerCase();
  }

  return (
    <RelatedInsightsContainer
      className="content-container"
      invertContrast={invert}
    >
      <FullWidthColumnWrapper>
        <h2>
          {authorName ? `${authorFirstName}'s Insights` : "Related Insights"}

          <span className="hr">
            <span />
          </span>
        </h2>

        <div className="articles-container">
          {articles.map((article, i) => {
            const rels = article.node.relationships;
            // const tags = (rels && rels.field_labs_tags) || undefined;
            const profile = getProfile(rels.author);

            return (
              <div
                className="articles-wrapper"
                key={i}
              >
                {/* <InsightsTeaserMinimal
                  invertContrast={invert}
                  htmlHeadingTag="h3"
                  created={article.node.created}
                  path={article.node.path.alias}
                  title={article.node.title}
                  tags={tags}
                /> */}

                <ArticleTeaser
                  created={article.node.created}
                  path={article.node.path.alias}
                  title={article.node.title}
                  htmlHeadingTag="h3"
                  author={profile.field_full_name}
                  cover={article.node.relationships.field_cover_image}
                />
              </div>
            );
          })}

          {authorName && (
            <aside className="articles-wrapper">
              <div className="more-link-container">
                <div className="more-link-wrapper">
                  <p className="more-link">
                    <span className="off-screen">
                      Click here to see
                      {" "}
                    </span>

                    <Link
                      type="none"
                      href={`/insights/${nameSlug}`}
                    >
                      <>
                        More
                        {" "}

                        <span className="keyword">
                          Insights
                        </span>

                        {" "}
                        by

                        {" "}

                        {authorFirstName}

                        <span className="icon-wrapper">
                          <Icon
                            className="icon"
                            icon="arrowRight"
                            size={2.4}
                          />
                        </span>
                      </>
                    </Link>
                  </p>
                </div>
              </div>
            </aside>
          )}

          {!authorName && (
            <aside className="articles-wrapper">
              <div className="more-link-container">
                <div className="more-link-wrapper">
                  <p className="more-link">
                    <span className="off-screen">
                      Click here to
                      {" "}
                    </span>

                    <Link
                      type="none"
                      href="/insights/"
                    >
                      <>
                        See more
                        {" "}

                        <span className="keyword">
                          Insights
                        </span>

                        <span className="icon-wrapper">
                          <Icon
                            className="icon"
                            icon="arrowRight"
                            size={2.4}
                          />
                        </span>
                      </>
                    </Link>
                  </p>
                </div>
              </div>
            </aside>
          )}
        </div>
      </FullWidthColumnWrapper>
    </RelatedInsightsContainer>
  );
};

export default RelatedInsights;
